<mat-icon class="material-icons icon" [ngClass]="{ 'material-icons-hover': hover }" [ngStyle]="styles()">
  <ng-content></ng-content>
</mat-icon>